export const QA_ACTIONS = {
  DOMAIN_LOADING: "DOMAIN_LOADING",
  CDE_LOADING: "CDE_LOADING",
  DOMAINS: "DOMAINS",
  CDES: "CDES",
  SEARCHING: "SEARCHING",
  SELECTED_DOMAIN: "SELECTED_DOMAIN",
  SELECTED_CDE: "SELECTED_CDE",
  DSDE_VALUES: "DSDE_VALUES",
  CURRENT_VIEW: "CURRENT_VIEW",
  SET_ALL_LOADING: "SET_ALL_LOADING",
  CLEAR_ALL_LOADING: "CLEAR_ALL_LOADING",
  SET_PAGE: "SET_PAGE",
  SET_RESULTS_PER_PAGE: "SET_RESULTS_PER_PAGE",
  SET_TABLE_DATA: "SET_TABLE_DATA",
  SET_TOTAL_RECORDS_COUNT: "SET_TOTAL_RECORDS_COUNT",
  SET_IS_TABLE_LOADING: "SET_IS_TABLE_LOADING",
  QA_METRICS: "QA_METRICS",
  TITLE: "TITLE",
};

export const initialState = {
  domains: [],
  cdes: [],
  qaMetrics: [],
  isSearching: false,
  isDomainLoading: false,
  isCDELoading: false,
  selectedDomain: undefined,
  selectedCde: undefined,
  dsdeValues: undefined,
  title: {},
  currentView: "charts",
  page: 1,
  per: 10,
  tableData: [],
  totalRecordsCount: 0,
  isTableLoading: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case QA_ACTIONS.DOMAIN_LOADING:
      return {
        ...state,
        isDomainLoading: action.payload,
      };
    case QA_ACTIONS.CDE_LOADING:
      return {
        ...state,
        isCDELoading: action.payload,
      };
    case QA_ACTIONS.DOMAINS:
      return {
        ...state,
        isDomainLoading: false,
        domains: action.payload,
      };
    case QA_ACTIONS.CDES:
      return {
        ...state,
        isCDELoading: false,
        cdes: action.payload,
      };
    case QA_ACTIONS.SEARCHING:
      return {
        ...state,
        isSearching: action.payload,
      };
    case QA_ACTIONS.SELECTED_DOMAIN:
      return {
        ...state,
        selectedDomain: action.payload,
      };
    case QA_ACTIONS.SELECTED_CDE:
      return {
        ...state,
        selectedCde: action.payload,
      };
    case QA_ACTIONS.DSDE_VALUES:
      return {
        ...state,
        dsdeValues: action.payload,
      };
    case QA_ACTIONS.CURRENT_VIEW:
      return {
        ...state,
        currentView: action.payload,
      };
    case QA_ACTIONS.TITLE:
      return {
        ...state,
        title: action.payload,
      };
    case QA_ACTIONS.SET_ALL_LOADING:
      return {
        ...state,
        isSearching: true,
        isDomainLoading: true,
        isCDELoading: true,
      };
    case QA_ACTIONS.CLEAR_ALL_LOADING:
      return {
        ...state,
        isSearching: false,
        isDomainLoading: false,
        isCDELoading: false,
      };
    case QA_ACTIONS.SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case QA_ACTIONS.SET_RESULTS_PER_PAGE:
      return {
        ...state,
        per: action.payload,
      };
    case QA_ACTIONS.SET_TABLE_DATA:
      return {
        ...state,
        tableData: action.payload,
      };
    case QA_ACTIONS.SET_TOTAL_RECORDS_COUNT:
      return {
        ...state,
        totalRecordsCount: action.payload,
      };
    case QA_ACTIONS.SET_IS_TABLE_LOADING:
      return {
        ...state,
        isTableLoading: action.payload,
      };
    case QA_ACTIONS.QA_METRICS:
      return {
        ...state,
        qaMetrics: action.payload,
      };
    default:
      return state;
  }
};
